import { makeStyles, colors } from "@material-ui/core";

const useTabStyles = makeStyles(
  (theme) => ({
    root: {
      overflow: "hidden",
      background: theme.palette.common.white,
    },

    wrapper: {
      position: "relative",
      width: "100%",
    },

    navBar: {
      position: "absolute",
      left: 0,
      top: 0,
      zIndex: 1000,

      height: "calc(100vh - 102px)",
      width: 500,
      borderRight: "1px solid #e8e8e8",
      overflow: "hidden",
    },

    navBarHeader: {
      height: 80,
      padding: "0px 33px",

      "& input": {
        paddingTop: 10,
        paddingBottom: 11,
        fontSize: 13,
      },
    },

    navBarHeaderContent: {
      width: "100%",
      paddingTop: 16,
    },

    navBarMenuWrapper: {
      height: "calc(100vh - 184px)",
    },

    navBarMenu: {
      padding: "0 0 14px 0",
      margin: 0,
      listStyleType: "none",
      overflow: "hidden",

      "& li": {
        listStyle: "none",
        cursor: "pointer",
        padding: "8px 30px",
        fontSize: 14,

        "&.title": {
          cursor: "default",
          color: colors.grey[600],
          fontWeight: theme.typography.fontWeightRegular,

          padding: "0px 32px 10px 32px",
        },

        "&.item": {
          borderLeft: `2px solid transparent`,

          "&.placeholder": {
            "&:hover": {
              backgroundColor: "transparent",
              cursor: "default",
            },
          },

          "&:hover": {
            backgroundColor: "#F3F2F2",
          },

          "&.selected": {
            backgroundColor: "#F3F2F2",
            borderLeft: `2px solid ${theme.palette.secondary.main}`,
          },

          "& .leftWrapper": {
            "& span": {
              display: "inline-block",
            },

            "& span:first-child": {
              fontWeight: theme.typography.fontWeightRegular,
            },

            "& span:last-child": {
              color: colors.grey[600],
              marginLeft: 4,
            },
          },
        },
      },
    },

    wrapperContent: {
      width: "100%",
      height: "calc(100vh - 101px)",
      overflow: "hidden",

      paddingLeft: 500,
    },

    wrapperContentInner: {},
  }),
  { name: "common-tab-styles", flip: null }
);

export default useTabStyles;
